import get from "lodash/get"
import PropTypes from "prop-types"
import React from "react"

import Footer from "../components/Footer"
import Header from "../components/Header"
import { PageProvider } from "../components/PageProvider"
import { floatingActionButtonTransformer } from "../utils/transformers"
import withSuspense from "../utils/withSuspense"

const CookieBanner = withSuspense(
  React.lazy(() => import("../components/CookieBanner"))
)
const MobileMenu = withSuspense(
  React.lazy(() => import("../components/MobileMenu"))
)
const Alert = withSuspense(React.lazy(() => import("../components/Alert")))
const FloatingActionButton = withSuspense(
  React.lazy(() => import("../components/FloatingActionButton"))
)

const BaseLayout = ({
  children,
  breadcrumbs,
  entry,
  entryLocalizedStrings,
  otherLanguages,
  global,
  localizedStrings,
  localNav,
  currentLanguage = "en",
  news,
}) => {
  const alert = get(global, "elements.alert.value[0]")
  const enableAlert = get(global, "elements.enable_alert.value[0].codename")
  const cookieConsentText = get(global, "elements.cookie_consent_text.value")
  const cookieConsentLinks = get(global, "elements.cookie_consent_text.links")
  const cookieConsentButtonText = get(
    global,
    "elements.cookie_consent_button_text.value"
  )
  const floatingActionButton =
    get(entry, "elements.floating_action_button.value[0]") ||
    get(entry, "elements.options__floating_action_button.value[0]")
  const isHome = (() => get(otherLanguages, "[0].system.type") === "home")()

  return (
    <PageProvider
      localizedStrings={
        entryLocalizedStrings
          ? [...entryLocalizedStrings.nodes, ...localizedStrings.nodes]
          : localizedStrings.nodes
      }
    >
      <div id="wrapper-outter">
        <MobileMenu global={global} currentLanguage={currentLanguage} />
        <div
          id="wrapper-inner"
          className="flex flex-col min-h-screen text-gray-900"
        >
          {isHome && alert && enableAlert === "yes" ? (
            <Alert alert={alert} />
          ) : null}
          <Header
            currentLanguage={currentLanguage}
            global={global}
            localizedStrings={localizedStrings}
            otherLanguages={otherLanguages}
            breadcrumbs={breadcrumbs}
            entry={entry}
            localNav={localNav}
          />
          <main className={"grow"}>
            {children}
            {floatingActionButton ? (
              <FloatingActionButton
                {...floatingActionButtonTransformer(floatingActionButton)}
                linkAttr={{
                  "data-analytics-title": get(
                    floatingActionButton,
                    "system.name"
                  ),
                }}
              />
            ) : null}
          </main>
          <Footer
            currentLanguage={currentLanguage}
            global={global}
            localizedStrings={localizedStrings}
            news={news}
          />
          <CookieBanner
            currentLanguage={currentLanguage}
            text={cookieConsentText}
            textLinks={cookieConsentLinks}
            buttonText={cookieConsentButtonText}
          />
        </div>
      </div>
    </PageProvider>
  )
}

/* eslint-disable-next-line import/no-anonymous-default-export */
export default function (props) {
  return <BaseLayout {...props} />
}

BaseLayout.propTypes = {
  currentLanguage: PropTypes.string,
  children: PropTypes.node.isRequired,
  otherLanguages: PropTypes.array,
}
